<template>
    <div class="text-center">
        <v-dialog v-model="dialog" width="60%">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    type="button"
                    v-bind="attrs"
                    v-on="on"
                    @click="loadSimulation()"
                >
                    <v-icon left small>mdi-feature-search-outline</v-icon>
                    {{ $t('forms.actions.simulate') }}
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="text-h5 grey lighten-2 mb-3">
                    {{ $t('resources.productSale.simulator.title') }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-data-table
                        :headers="tableHeaders"
                        :items="periods"
                        class="elevation-1"
                        hide-default-footer
                        :loading="loading"
                        :items-per-page="-1"
                    >
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialog = false">
                        {{ $t('resources.productSale.simulator.close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ProductSale from '@/models/product/ProductSale'
import ProductSalePeriod from '@/models/product/ProductSalePeriod'

export default {
    props: {
        titlePrefix: String,
        disabled: {
            type: Boolean,
            default: true,
        },
        sale: {
            type: Object,
            required: true,
            validator: sale => {
                return sale instanceof ProductSale
            },
        },
    },

    data() {
        return {
            dialog: false,
            loading: true,
            data: [],
        }
    },

    computed: {
        tableHeaders() {
            return [
                {
                    text: this.$t(
                        'resources.productSalePeriod.attributes.payment_method',
                    ),
                    value: 'formattedPaymentMethod',
                    align: 'center',
                },
                {
                    text: this.$t(
                        'resources.productSalePeriod.attributes.installment',
                    ),
                    value: 'formattedInstallment',
                    align: 'center',
                },
                {
                    text: this.$t(
                        'resources.productSalePeriod.attributes.price',
                    ),
                    value: 'formattedPrice',
                    align: 'center',
                },
                {
                    text: this.$t(
                        'resources.productSalePeriod.attributes.due_at',
                    ),
                    value: 'formattedDueAt',
                    align: 'center',
                },
            ]
        },

        periods() {
            let periods = []
            this.data.forEach(period => {
                var model = new ProductSalePeriod()
                model.formattedPaymentMethod = model.getFormattedPaymentMethod(
                    period.payment_method,
                )
                model.formattedInstallment = model.getFormattedInstallment(
                    period.installment,
                )
                model.formattedPrice = model.getFormattedPrice(period.price)
                model.formattedDueAt = model.getFormattedDueAt(period.due_at)
                periods.push(model)
            })
            return periods
        },
    },

    methods: {
        async loadSimulation() {
            this.dialog = true
            let res = await this.sale.simulate()
            if (!res || !res.data) {
                this.dialog = false
                return
            }

            this.data = res.data.data
            this.loading = false
        },
    },
}
</script>

<style></style>
